<div [ngClass]="{'pe-testimonial':true,'pe-no-margin':item.data.fullWidth}"
     [ngStyle]="{backgroundColor:item.data.bgColor,
             color:item.data.textColor,
              maxWidth:layoutSetting.maxWidth + 'px'}">
  <app-sub-component-container [layoutSetting]="layoutSetting" [item]="item">
    <div class="pe-t-header">
      {{ item.data.header}}
    </div>
    <div class="pe-t-description">
      {{item.data.description}}
    </div>
    <div class="pe-list-testimonial">
      <div class="pe-item-testimonial" [ngStyle]="{ alignItems:cs.alignToFlex(item.data.align)}" *ngFor="let testimonial of item.data.list">

        <img [attr.src]="imageSelector(testimonial.image)" class="pe-i-t-image">

        <div class="pe-i-t-text">
          {{ testimonial.text}}
        </div>
        <div class="pe-i-t-name">
          {{ testimonial.name}}
        </div>
      </div>
    </div>
  </app-sub-component-container>
</div>
